import type { FileFullRepresentationsEntriesField } from 'box-typescript-sdk-gen/lib/schemas/fileFull.generated';
import type { Dispatch, SetStateAction } from 'react';
import type { FileInfo } from 'src/pages/advisor/dashboard/marketing/asset/[boxFileId]';
import { Button } from '@savvy-kit/components/button';
import { Separator } from '@savvy-kit/components/separator';
import { Skeleton } from '@savvy-kit/components/skeleton';
import { Text } from '@savvy-kit/foundations/text';

function AssetDownloadFormats({
  fileInfo,
  selectedFormat,
  setSelectedFormat,
  setSize,
}: {
  readonly fileInfo: FileInfo;
  readonly selectedFormat: string;
  readonly setSelectedFormat: Dispatch<SetStateAction<string>>;
  readonly setSize: Dispatch<SetStateAction<string>>;
}) {
  const originalFormat = fileInfo.originalFormat;
  const representations = fileInfo.representations;
  const loading = fileInfo.name === '';

  const handleFileFormatChange = (event: React.MouseEvent<HTMLButtonElement>) => {
    const newFormat = event.currentTarget.value;
    setSelectedFormat(newFormat);

    const matchingReps = representations.filter((item: FileFullRepresentationsEntriesField) => {
      return item.representation === newFormat;
    });
    if (newFormat === originalFormat) {
      setSize('');
    } else if (matchingReps[0]?.properties?.dimensions) {
      setSize(matchingReps[0].properties.dimensions);
    }
  };

  const formatOptions = {
    pdf: ['pdf', 'jpg', 'png'],
    jpg: ['jpg', 'png'],
    png: ['png', 'jpg'],
  }[originalFormat] || [originalFormat];

  const fileFormatButtons = formatOptions.map((fileFormatOption) => {
    const isSelected = fileFormatOption === selectedFormat;
    return (
      <Button
        key={fileFormatOption}
        value={fileFormatOption}
        variant="secondary"
        size="sm"
        className={`w-[100px] ${isSelected && 'bg-component-hover'}`}
        onClick={handleFileFormatChange}
      >
        {fileFormatOption.toUpperCase()}
      </Button>
    );
  });
  return (
    <>
      <Separator className="bg-border-light" />
      <div className="flex flex-col gap-2 p-4 pt-2 w-full">
        <Text variant="subtitle-sm">File format</Text>
        <div className="flex flex-col gap-2">
          {loading ? <Skeleton className="h-8 w-[100px] rounded" /> : fileFormatButtons}
        </div>
      </div>
    </>
  );
}

export default AssetDownloadFormats;
